function decodeAppleJwsPayload(purchaseToken) {
  try {
    const parts = String(purchaseToken || "").split(".");
    if (parts.length < 2) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    if (typeof atob !== "function") {
      return null;
    }
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

const OFFER_ID_LABELS = {
  "monthly-7day-trial": "일주일 무료체험",
};

const BASE_PLAN_ID_LABELS = {
  "talktalktalk-monthly-subscription": "월 구독",
  "talktalktalk-yearly-subscription": "년 구독",
};

const IOS_PRODUCT_ID_LABELS = {
  talktalktalk_ios_monthly: "월 구독",
  talktalktalk_ios_yearly: "년 구독",
};

export function getOfferIdLabel(offerId) {
  const normalized = String(offerId || "").trim();
  if (!normalized) {
    return "";
  }
  return OFFER_ID_LABELS[normalized] || normalized;
}

export function getBasePlanIdLabel(basePlanId) {
  const normalized = String(basePlanId || "").trim();
  if (!normalized) {
    return "";
  }
  return BASE_PLAN_ID_LABELS[normalized] || normalized;
}

export function getIosProductLabel(payment) {
  const productId = String(
    payment?.productID || payment?.productId || ""
  ).trim();

  if (!productId) {
    return "-";
  }

  return IOS_PRODUCT_ID_LABELS[productId] || productId;
}

export function getAndroidProductLabel(payment) {
  const basePlanLabel = getBasePlanIdLabel(payment?.basePlanId);
  const offerLabel = getOfferIdLabel(payment?.offerId);

  if (offerLabel && basePlanLabel) {
    return `${basePlanLabel} / ${offerLabel}`;
  }
  if (offerLabel) {
    return offerLabel;
  }
  if (basePlanLabel) {
    return basePlanLabel;
  }

  return (
    payment?.productID ||
    payment?.productId ||
    payment?.lineItemProductId ||
    "-"
  );
}

export function getEffectivePaymentStatus(payment) {
  const expiryMillis = Number(payment?.expiryTimeMillis || 0);
  if (expiryMillis > 0 && Date.now() >= expiryMillis) {
    return "expired";
  }
  return payment?.status || "";
}

export function getSubscriptionTypeLabel(payment) {
  if (payment?.type) {
    return `(${payment.type})`;
  }

  let transactionReason = payment?.transactionReason || "";
  let offerDiscountType = payment?.offerDiscountType || "";
  let offerPeriod = payment?.offerPeriod || "";

  if (
    String(payment?.platform || "").toLowerCase() === "ios" &&
    payment?.purchaseToken &&
    (!transactionReason || !offerDiscountType)
  ) {
    const payload = decodeAppleJwsPayload(payment.purchaseToken);
    transactionReason = transactionReason || payload?.transactionReason || "";
    offerDiscountType = offerDiscountType || payload?.offerDiscountType || "";
    offerPeriod = offerPeriod || payload?.offerPeriod || "";
  }

  if (offerDiscountType === "FREE_TRIAL" || offerPeriod) {
    return offerPeriod ? `무료체험` : "무료체험";
  }

  if (String(transactionReason).toUpperCase() === "RENEWAL") {
    return " 갱신";
  }

  if (String(transactionReason).toUpperCase() === "PURCHASE") {
    const priceValue = String(payment?.price || "").split(":")[0];
    if (priceValue === "0" || priceValue === "") {
      return "구독 시작";
    }
    return "정기구독";
  }

  if (payment?.offerId && /trial/i.test(String(payment.offerId))) {
    return /7day/i.test(String(payment.offerId)) ? "무료체험(7일)" : "무료체험";
  }

  if (String(payment?.paymentState) === "2") {
    return "무료체험";
  }

  const notificationType = Number(payment?.notificationType);
  if (notificationType === 2 || notificationType === 1) {
    return " 갱신";
  }
  if (notificationType === 4 || notificationType === 7) {
    return "구독 시작";
  }

  if (payment?.offerId) {
    return payment.offerId;
  }

  return "-";
}

export function getPaymentStatusLabel(status) {
  const statusMap = {
    active: "활성",
    canceled: "취소",
    expired: "만료",
    cancellation_scheduled: "해지 예정",
    revoked: "철회",
    pending_purchase_canceled: "구매 취소",
  };
  return statusMap[String(status || "").toLowerCase()] || status || "-";
}

// export function getAutoRenewingLabel(value) {
//   if (value === true) {
//     return "ON";
//   }
//   if (value === false) {
//     return "OFF";
//   }
//   return "-";
// }
